<template>
    <div class="background" :style="{'background': 'url(' + theImage + ')'}">
        <div class="transbox">
            <div class="transboxContent">
                <h2>{{ $t('regulations.Header') }}</h2>
                {{ $t('regulations.HeaderText') }}
                <br />
                {{ $t('regulations.Subheader') }}
                <br />
                <ul>
                    <li>{{ $t('regulations.Listelement1') }}</li>
                    <li>{{ $t('regulations.Listelement2') }}</li>
                    <li>{{ $t('regulations.Listelement3') }}</li>
                    <li>{{ $t('regulations.Listelement4') }}</li>
                    <li>{{ $t('regulations.Listelement5') }}</li>
                    <li>{{ $t('regulations.Listelement6') }}</li>
                    <li>{{ $t('regulations.Listelement7') }}</li>
                    <li>{{ $t('regulations.Listelement8') }}</li>
                    <li>{{ $t('regulations.Listelement9') }}</li>
                </ul>
                <br />
                {{ $t('regulations.Linktext') }}
                <br />
                <a href="https://www.nwtu.de">NWTU</a>
                <br />
                <br />
                <br />
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import { EventBus } from '@/classes/eventBus.js';

    export default {
        props: {
            linkItem: String,
            myText: String
        },
        data: function () {
            return {
                theImage: '',
            }
        },
        computed: {
        },
        mounted() {
            EventBus.$on('backgroundImageChange', image => {
                this.theImage = image;
            });
        },
        methods: {
        }
    }
</script>

<style scoped>
    @import '../css/main.css';
</style>